import { BaseVisualization } from '../base/base-visualization-component'
import { IVisOptions } from '../../types'

/**
 * Double widget class that displays two widget in the same card.
 * Payload passed to this component is expected to have "extendedData"
 * as key
 */
export class DoubleChartComponent extends BaseVisualization {
 static config = {
  selector: 'afDoubleChart',
  controller: DoubleChartComponent,
  bindings: BaseVisualization.config.bindings,
  template: `
        <div class="double__container" layout="row" layout-wrap>
            <div class="flex-xs-100 flex-sm-100 flex-md-25 flex-lg-25 flex-xl-25 flex share-hide">
                <div ng-if="!$ctrl.isLoading && $ctrl.charts[0]""
                    class="af__chart__container donut-shrink"
                    dynamic-charts="$ctrl.charts[0].chartId" dyn="$ctrl.charts[0].chartId" props="$ctrl.charts[0].options">
                </div>
            </div>

            <div class="flex-xs-100 flex-sm-100 flex-md-75 flex-lg-75 flex-xl-75 flex share-expand">
                <div ng-if="!$ctrl.isLoading && $ctrl.charts[1]"
                    class="af__chart__container"
                    dynamic-charts="$ctrl.charts[1].chartId" dyn="$ctrl.charts[1].chartId" props="$ctrl.charts[1].options">
                </div>
            </div>
        </div>
        `,
 }

 public extendedData: any
 public widgetKeys: string[] = []
 public visOptionsSpline: IVisOptions = {}
 public charts = []

 $onInit() {
  this.sortByDate(this.vizData.extendedData)
  this.prepareVisualizations(this.vizData.extendedData)
 }

 /**
     * Method is triggered after changes in the datastore.
     * Thereafter, trigger methods to update the view.
     * @param changes data object with current and previous change value(s)
   //   */
 $onChanges(changes) {
  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
  }
  if (this.hasChanges(changes.vizData)) {
   this.setProperties()
   this.prepareGranularity(changes.vizData.currentValue)
   this.prepareVisualizations(changes.vizData.currentValue.extendedData)
  } else {
   //TODO: log to sentry.io - probably error with/loading data
  }
 }

 setProperties() {}

 prepareGranularity(data) {
  if (typeof data.originalViewRequest !== 'undefined') {
   Object.keys(data.extendedData).forEach((o, i) => {
    data.extendedData[o] = {
     ...data.extendedData[o],
     originalViewRequest: data.originalViewRequest,
    }
   })
  }
 }

 /**
  * This function will prepare data for generating both charts a chart.
  * This is currently getting the component tag passed in from charts factory
  * The goal is the backen would retutn the tags that would generate the necc charts
  */
 prepareVisualizations(data) {
  this.charts = []
  this.charts.push(this.createChart(0, data))
  this.charts.push(this.createChart(1, data))
 }

 sortByDate(data) {
   if(data.spline != undefined) {
     Object.keys(data.spline.data).forEach(queryName => {
       if(data.spline.data[queryName] != undefined) {
        this.mergeValuesWithSameKey(data.spline.data[queryName])
        data.spline.data[queryName].sort(function(a, b) {
         return a.key - b.key
        })
       }
     })
   }
 }

 mergeValuesWithSameKey(data) {
  let keys = new Set()
  for(let i = 0; i < data.length; i++) {
    let curKey = data[i].key
    if(keys.has(curKey)) {
      for(let j = 0; j < i; j++) {
        if(data[j].key === curKey) {
          data[j].value += data[i].value
            break
        }
      }
      data.splice(i--,1)
      continue
    }
    keys.add(curKey)
  }
 }

 createChart(index, data) {
  return {
   chartId: this.options.subWidgets[index],
   options: {
    visualizationId: this.visualizationId,
    triggerUpdate: this.triggerUpdate,
    vizData: data[Object.keys(data)[index]],
    title: this.visTitle,
    size: this.size,
    isLoading: this.isLoading,
    isError: this.isError,
    dateRange: this.dateRange,
    pagination: this.pagination,
    csvExportProfiles: this.csvExportProfiles,
    visualizationMetaData: this.visualizationMetaData,
    userTimeZone: this.properties.userTimeZone,
   },
  }
 }
}
